import { api } from "@/config";

export const orders = {
  url(_path = "") {
    let path = _path != "" ? `/${_path}` : "";
    return `/orders${path}`;
  },
  namespaced: true,
  actions: {
    get({ context }, params) {
      return api.get(orders.url(), {
        params: params,
      });
    },
    show({ context }, { order_id }) {
      return api.get(orders.url(order_id));
    },
    add({ context }, { payload }) {
      return api.post(orders.url(), payload);
    },
    delete({ context }, { orderId }) {
      return api.delete(orders.url(orderId));
    },
    searchOrderByRef({ context }, searchQuery) {
      try {
        return api.get(orders.url(`search/${searchQuery}`));
      } catch (error) {
        console.log("Error in searching order by reference: ", error);
        throw error;
      }
    },

    async submitOrderProductPayment({ context }, payload) {
      try {
        const response = await api.patch(orders.url(`pay-multiple-product`), payload);
        return response.data;
      } catch (error) {
        // Optional: Log the error for debugging
        console.error("Payment failed:", error);

        // Extract meaningful error message
        const message_1 = error.response?.data?.message ||
          "Something went wrong during payment.";

        // You can throw the message or full error object depending on your needs
        throw new Error(message_1);
      }
    },
  },
};
